/**
 * Serializes enumerated screens into the `screen_list` / `is_multiple_screens` pair the servers store.
 * Shared by the post-pairing tenant update (SignageApplication.monitoringLoop) and the pre-pairing
 * auth-server report, so both servers hold an identical shape for the same device.
 */
export function buildScreenListPayload(screens) {
    const screen_list = screens
        .filter((screen) => screen.identifier && !screen.identifier.toString().toLowerCase().startsWith('none'))
        .map((screen) => screen.serialize());
    return { screen_list, is_multiple_screens: screen_list.length > 1 };
}
//# sourceMappingURL=ScreenListPayload.js.map